interface LoadingSpinnerProps {
  label?: string;
}

export function LoadingSpinner({ label = 'Carregando...' }: LoadingSpinnerProps) {
  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-3 text-secondary-600">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
